export default __webpack_public_path__ + "static/media/Quote_Orange.bd4f316b.svg";